import { render, staticRenderFns } from "./veStuCheckItemEdit.vue?vue&type=template&id=64a79ad8&scoped=true"
import script from "./veStuCheckItemEdit.vue?vue&type=script&lang=js"
export * from "./veStuCheckItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a79ad8",
  null
  
)

export default component.exports